"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var component_icon_font_1 = __importDefault(require("@rotaryintl/component-icon-font"));

var hook_use_bem_classes_1 = __importDefault(require("@rotaryintl/hook-use-bem-classes"));

var classnames_1 = __importDefault(require("classnames"));

var link_dropdown_component_1 = __importDefault(require("../link-dropdown/link-dropdown.component"));

var link_component_1 = require("../link/link.component");

var link_helpers_1 = require("../link/link.helpers");
/** The desktop utility nav. Mobile version is rendered in the header-menu.component */


var HeaderUtilityNav = function (props) {
  var _a, _b;

  if (!props.utilityNavLinks || props.utilityNavLinks.length <= 0) return null;
  var bem = (0, hook_use_bem_classes_1.default)('rwc-header-utility-nav');
  return (0, jsx_runtime_1.jsx)("div", __assign({
    className: bem()
  }, {
    children: (0, jsx_runtime_1.jsxs)("ul", __assign({
      className: bem('items')
    }, {
      children: [(_a = props.utilityNavLinks) === null || _a === void 0 ? void 0 : _a.map(function (link) {
        return (0, jsx_runtime_1.jsx)("li", {
          children: (0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({
            className: bem('item')
          }, link))
        }, "".concat(bem('item'), "-").concat(link.linkText, "-").concat(link.linkUrl));
      }), props.selectedLanguage && props.languageLinks && (0, jsx_runtime_1.jsx)("li", {
        children: (0, jsx_runtime_1.jsx)(link_dropdown_component_1.default, {
          metadataName: "language-select",
          icon: "fas-globe",
          buttonClasses: bem('item'),
          label: props.selectedLanguage,
          links: (_b = props.languageLinks) === null || _b === void 0 ? void 0 : _b.map(link_helpers_1.createLanguageLink),
          onChange: function (link) {
            if (props.onLanguageSelect) {
              props.onLanguageSelect(link);
            }
          },
          displaySelectedCheckmark: true
        })
      }), props.signInLink && props.registerLink ? (0, jsx_runtime_1.jsxs)("li", __assign({
        className: bem('sign-in-links')
      }, {
        children: [(0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({
          className: (0, classnames_1.default)(bem('item'), bem('sign-in')),
          preLinkText: (0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
            type: "fas-circle-user",
            size: "16"
          })
        }, props.signInLink)), (0, jsx_runtime_1.jsx)("span", {
          children: "|"
        }), (0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({
          className: (0, classnames_1.default)(bem('item'), bem('register'))
        }, props.registerLink))]
      })) : props.accountLabel && props.accountLinks && (0, jsx_runtime_1.jsx)("li", {
        children: (0, jsx_runtime_1.jsx)(link_dropdown_component_1.default, {
          metadataName: "account-menu",
          icon: "fas-circle-user",
          buttonClasses: bem('item'),
          label: props.accountLabel,
          links: props.accountLinks
        })
      })]
    }))
  }));
};

exports.default = HeaderUtilityNav;